/* global google, markers */

/**
 * Google Map
 * ======================================
 * https://developers.google.com/maps/documentation/javascript/tutorial
 */

const WIDGET = '.js-map'
const MOBILE = window.outerWidth < 768
const ZOOM = MOBILE ? 7 : 8

class Map {
	constructor() {
		const element = document.querySelector(WIDGET)

		if (!element) {
			return false
		}

		const pos_lat = parseFloat(element.getAttribute('data-lat'))
		const pos_lng = parseFloat(element.getAttribute('data-lng'))

		const mapOptions = {
			zoom: ZOOM,
			center: { lat: pos_lat, lng: pos_lng },
			disableDefaultUI: true,
			zoomControl: true,
			scrollwheel: false
		}

		const map = new google.maps.Map(element, mapOptions)

		/**
		 * Styled map
		 */
		const styledMapType = new google.maps.StyledMapType(this.getStyles())

		map.mapTypes.set('customMapStyle', styledMapType)
		map.setMapTypeId('customMapStyle')

		const iconSvg = {
			url: '/app/themes/ipress/build/images/marker-gmap.svg',
			scaledSize: new google.maps.Size(21, 30)
		}

		const iconSvgLarge = {
			url: '/app/themes/ipress/build/images/marker-gmap.svg',
			scaledSize: new google.maps.Size(33, 47)
		}

		if (markers) {
			markers.forEach(item => {
				const marker = new google.maps.Marker({
					icon: item.large ? iconSvgLarge : iconSvg,
					optimized: false,
					title: item.title,
					position: { lat: item.map.lat, lng: item.map.lng }
				})
				marker.setMap(map)
			})
		}
	}

	getStyles = () => {
		return [
			{
				featureType: 'administrative',
				elementType: 'geometry',
				stylers: [
					{
						visibility: 'on'
					}
				]
			},
			{
				featureType: 'administrative.neighborhood',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'poi',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'road',
				elementType: 'labels',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'road',
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'road.arterial',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'road.highway',
				elementType: 'labels',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'road.local',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'transit',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'water',
				elementType: 'labels.text',
				stylers: [
					{
						visibility: 'off'
					}
				]
			}
		]
	}
}

new Map()
